const TERMINAL_NAME_VALIDATION_REGEX =
  /^[A-Za-z0-9\-\ \.\_]{1,32}$/;

export const validateTermName = (term_name: string) => {
  return TERMINAL_NAME_VALIDATION_REGEX.test(term_name.trim());
};
